import { get, omit } from "lodash";
import { actions } from "./Actions";
import immutableSet from "@configuratorware/configurator-frontendgui/Utils/Immutable/set";

const initialState = {
  items: [],
  uuid: null,
  selectedBasketItem: null,
  clearData: false,
  orders: [],
  mailFailed: false,
  configurationFromList: false
};

export function basket(state = initialState, action) {
  switch (action.type) {
    case actions.RECEIVE_BASKET: {
      return {
        ...state,
        ...action.data,
        clearData: false,
        mailFailed: false
      }
    }
    case actions.SET_SELECTED_BASKET_ITEM: {
      return {
        ...state,
        selectedBasketItem: action.item
      }
    }
    case actions.SET_SELECTED_ITEM_AMOUNT: {
      const selectedAmountsPath = 'configuration.customdata.selectedAmounts';
      const selectedAmounts = get(state.selectedBasketItem, selectedAmountsPath, {});
      const selectedBasketItem = immutableSet(
          state.selectedBasketItem,
          selectedAmountsPath,
          action.amount === 0
              ? omit(selectedAmounts, action.identifier)
              : { ...selectedAmounts, [action.identifier]: action.amount }
      );
      return {...state, selectedBasketItem};
    }
    case actions.CLEAR_BASKET: {
      return {
        ...state,
        items: [],
      }
    }
    case actions.CLEAR_BASKET_DATA: {
      return {
        ...state,
        items: [],
        uuid: null,
        clearData: true,
        mailFailed: false
      }
    }
    case actions.SET_MAIL_ERROR: {
      return {
        ...state,
        clearData: false,
        mailFailed: true
      }
    }
    case actions.RECEIVE_ORDERS: {
      return {
        ...state,
        orders: action.data
      }
    }
    case actions.SET_CONFIGURATION_LOAD_FROM_LIST: {
      return {
        ...state,
        configurationFromList: action.data
      }
    }
    case actions.SET_SHOW_SELECTOR: {
      return {
        ...state,
        showSelector: action.flag
      }
    }
    default:
      return state;
  }
}

export default basket;
